import { render, staticRenderFns } from "./NoDataAvailableComponent.vue?vue&type=template&id=bc80b86e&scoped=true"
import script from "./NoDataAvailableComponent.js?vue&type=script&lang=js&external"
export * from "./NoDataAvailableComponent.js?vue&type=script&lang=js&external"
import style0 from "./NoDataAvailableComponent.vue?vue&type=style&index=0&id=bc80b86e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc80b86e",
  null
  
)

export default component.exports